import {
  Step,
  StepButton,
  Stepper,
  Typography,
  Tooltip,
} from "@material-ui/core";
import React from "react";
import styled from "styled-components";

const TypographyContainer = styled.div``;

const ProxyContainer = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
`;

function isStepActive(step, actionWorkflows, activeStep, index) {
  // if workflow is present on the action then check if it exists in masterWorkflow to activate that step
  // else make only the selected step as active
  if (actionWorkflows) {
    const workflowsAssigned = actionWorkflows.filter((af) => {
      return af.assigneeBun === step.assigneeBun && af.label === step.label;
    });
    return workflowsAssigned.length > 0 ? true : false;
  } else {
    return activeStep === index ? true : false;
  }
}

const ActionsStepperV2 = ({
  actionWorkflows,
  workflows,
  activeStep,
  onStepIndexChanged = () => {},
  pendingActionsCounts
}) => {
  return (
    <div style={{ minHeight: 128 }}>
      <Stepper
        style={{ padding: 12 }}
        alternativeLabel
        nonLinear
        activeStep={activeStep}
      >
        {workflows.map((step, index) => {
          let proxiesLabel = undefined;
          let proxyCaption = undefined;
          return (
            <Step
              completed={false}
              key={index}
              active={isStepActive(step, actionWorkflows, activeStep, index)}
            >
              <StepButton onClick={() => onStepIndexChanged(index)}>
                {step.label} 
                {pendingActionsCounts[index] ? ` (${pendingActionsCounts[index]})`:` (0)`}
                <br />
                <TypographyContainer>
                  {step &&
                    step.proxy &&
                    step.proxy.map((proxy, index) => {
                      proxiesLabel = proxiesLabel
                        ? proxiesLabel + " : " + proxy.displayName
                        : proxy.displayName;

                      proxyCaption = step.proxy.length;
                    })}
                  <Typography variant="caption">
                    {step.isCurrentUser && !step.isProxy ? (
                      <b>{step.assignee}</b>
                    ) : (
                      step.assignee
                    )}
                    <br />
                    {/* {step.isCurrentUser &&
                    step.isProxy &&
                    step.proxy.length > 0 ? (
                      <b>{step.proxy[0].displayName}</b>
                    ) : (
                      ""
                    )} */}
                    {/* {//!step.isCurrentUser &&
                    !step.isProxy &&
                    step.proxy &&
                    step.proxy.length === 1 &&
                    step.proxy.length > 0
                      ? step.proxy[0].displayName
                      : ""} */}
                    {step && step.proxy && step.proxy.length === 1 ? (
                      step.isCurrentUser ? (
                        <b>{step.proxy[0].displayName}</b>
                      ) : (
                        step.proxy[0].displayName
                      )
                    ) : (
                      ""
                    )}
                    {
                      // !step.isCurrentUser &&
                      // !step.isProxy &&
                      step && step.proxy && step.proxy.length > 1 ? (
                        <Tooltip title={proxiesLabel}>
                          <ProxyContainer>
                            {proxyCaption} Proxies{" "}
                          </ProxyContainer>
                        </Tooltip>
                      ) : (
                        ""
                      )
                    }
                  </Typography>
                </TypographyContainer>
              </StepButton>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
};

export default ActionsStepperV2;
